module.exports = __webpack_public_path__ + "img/image_arm@2x.1de9ba14.png";